import { DEPARTMENT_CHART_COLORS } from "../constants/candidateStatus";
import { HRDashboardData } from "../types";

export interface DashboardStatsView {
  totalApplications: number;
  pendingATS: number;
  selected: number;
  todayApplications: number;
  interviews: number | null;
  selectionRate: number;
  voiceCallsToday: number | null;
  voiceCallsWeek: number | null;
  voiceCallSuccessRate: number | null;
  departmentHiring: Array<{
    name: string;
    count: number;
    percentage: number;
    color: string;
  }>;
}

export const mapDashboardStats = (
  dashboardData: HRDashboardData | null | undefined
): DashboardStatsView => ({
  totalApplications: dashboardData?.summary?.totalApplications ?? 0,
  pendingATS: dashboardData?.summary?.pendingATS ?? 0,
  selected: dashboardData?.summary?.selected ?? 0,
  todayApplications: dashboardData?.today?.applications ?? 0,
  interviews: dashboardData?.today?.interviewsScheduled ?? null,
  selectionRate: dashboardData?.summary?.selectedRate ?? 0,
  voiceCallsToday: dashboardData?.today?.voiceCalls ?? null,
  voiceCallsWeek: dashboardData?.voiceCalls?.thisWeek ?? null,
  voiceCallSuccessRate: dashboardData?.voiceCalls?.successRate ?? null,
  departmentHiring: (dashboardData?.departmentHiring ?? []).map((dept, index) => ({
    name: dept.department,
    count: dept.count,
    percentage: dept.percentage,
    color: DEPARTMENT_CHART_COLORS[index % DEPARTMENT_CHART_COLORS.length],
  })),
});
